

































































import { PropType } from 'vue';
import moment from 'moment';

import Proxyable from '@/mixins/proxyable';

import mixins from '@/utils/mixins';
import { IQuoteData, IQuoteFieldError, QuoteFieldError } from '@/models';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { requiredValidator } from '@/utils/validators';
import { ALForm } from '@/common/component.types';
import DatePicker from '../common/DatePicker.vue';

const baseMixins = mixins(Proxyable);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuoteRFQFormDialog',

    components: { ConfirmationDialog, DatePicker },

    props: {
      errorMessage: {
        type: String
      },

      fieldError: {
        type: Object as PropType<IQuoteFieldError>,
        default: () => new QuoteFieldError()
      },
      loading: {
        type: Boolean,
        default: () => false
      }
    },

    data: () => ({
      dialog: false,
      dateMenu: false,
      isFormValid: false,
      quoteData: {
        rfq_number: null,
        rfq_date: ''
      } as IQuoteData
    }),

    methods: {
      requiredValidator,

      open() {
        this.dialog = true;
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      async save() {
        if (this.validateForm()) {
          if (this.quoteData.rfq_number === '') {
            this.quoteData.rfq_number = null;
          }
          this.$emit('save', this.quoteData);
        }
      },

      clearErrors() {
        this.$emit('clearErrors');
      },

      allowedDates: (val: string) => {
        // disable all future dates
        return moment(val).isSameOrBefore(new Date(), 'day');
      }
    }
  });
